
import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAllDataIndividaulList, getIndividaulList } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import { LocationContext } from '../../../context/LocationContext';
import DistrictFilter from '../districtFilter/DistrictFilter';
import CategorySubCategoryFilter from '../categorySubCateogoryFilter/CategorySubCategoryFilter';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import RefreshButton from '../../../jsx/components/RefreshButton/RefreshButton';
import { useFilterReset } from '../../../hooks/useFilterReset';
import SportFilter from '../sportFilter/SportFilter';
import { useSport } from '../../../context/SportContext';
import DownloadExcelButton from '../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton';
import { IndividualExcelHeaders } from './IndividualExcelHeader';
import { AuthContext } from '../../../context/AuthContext';
import { exportVerifiedToExcel } from '../../../utils/exportToExcel';
import TextMasked from '../../../utils/TextMasked';
const IndividualList = () => {
    const { user } = useContext(AuthContext);
    const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
    const { selectedSubCategoryId, setSelectedSubCategoryId } = useCategoryFilter();
    const [organisationdataList, setOrganisationdataList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const navigate = useNavigate();
    const handleVerificationClick = (id) => {
        localStorage.removeItem('remarksIndividual');
        navigate(`/verification-Individual-form/${id}`); // Absolute path
    };
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const { selectedSportId, setSelectedSportId } = useSport();


    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
        setCurrentPage(1);
    };
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const getOrganisationListApi = async (perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId) => {
        setLoading(true);
        try {
            const response = await getIndividaulList(perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId);

            setOrganisationdataList(response?.data?.data);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId);
    }, [currentPage, perPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId]);

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };
    const handleRefresh = useFilterReset({
        setSearchValue,
        setDebouncedSearchValue,
        setSelectedStatus,
        setSelectedDistrictId,
        setSelectedSubCategoryId,
        setCurrentPage,
        setSelectedCategory,
        setSelectedSubCategory,
        setSelectedSportId,
        setPerPage,
        fetchFunction: getOrganisationListApi,
        fetchArgs: [10, 1, 0, "", "", "", "", ""]


    });

    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        setSelectedStatus(0);
        setDebouncedSearchValue("");
        setSelectedDistrictId("");
        setSelectedSubCategoryId("");
        setSelectedSportId("");
    }, []);

    // const handleDataToExcel = async () => {
    //     alert("hell")
    //     try {
    //         const response = await getAllDataIndividaulList(selectedStatus, debouncedSearchValue, selectedDistrictId, selectedSubCategoryId, selectedSportId);
    //         const data = response.data;
    //         exportVerifiedToExcel(data, "InsitutionListVerified.csv");
    //     } catch (error) {
    //         console.error('Login error:', error);
    //     }
    // };
    return (
        <>
            <PageTitle
                activeMenu="Individual List"
                motherMenu="Manage Registration"
            />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-lg-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1); // ✅ reset to first page
                                }}

                                />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>


                        </div>

                        <div className="d-flex mt-3">

                            {/* <div className="mx-2">
                                <DownloadExcelButton
                                    onClick={async () => {
                                        const response = await getAllDataIndividaulList(
                                            selectedStatus,
                                            debouncedSearchValue,
                                            selectedDistrictId,
                                            selectedSubCategoryId,
                                            selectedSportId
                                        );
                                        console.log("responseData===>", response.data)

                                        const allData = response?.data || [];
                                        const withSerial = allData.map((item, index) => ({
                                            serial: index + 1,  // matches header key
                                            ...item
                                        }));

                                        return withSerial;
                                    }}
                                    data={
                                        (organisationdataList?.data || organisationdataList || []).map((item, index) => ({
                                            serial: index + 1, // ✅ add serial number
                                            ...item,
                                        }))
                                    }
                                    headers={[
                                        { label: "Sr.No", key: "serial" }, // ✅ add serial header
                                        ...IndividualExcelHeaders,
                                    ]}
                                    btnName="Download Excel"
                                    fileName="Individual.xlsx" />
                            </div> */}

                            <div className="mx-2">
                                <DownloadExcelButton
                                    onClick={async () => {
                                        try {
                                            const response = await getAllDataIndividaulList(
                                                selectedStatus,
                                                debouncedSearchValue,
                                                selectedDistrictId,
                                                selectedSubCategoryId,
                                                selectedSportId
                                            );

                                            const csvData = response?.data;

                                            console.log("CSV DATA:", csvData);

                                            if (!csvData || typeof csvData !== "string") {
                                                console.error("Invalid CSV data");
                                                return;
                                            }

                                            // ✅ Direct download (same as verified)
                                            const blob = new Blob([csvData], {
                                                type: "text/csv;charset=utf-8;",
                                            });

                                            const link = document.createElement("a");
                                            link.href = window.URL.createObjectURL(blob);
                                            link.download = "Individual.csv";
                                            link.click();

                                        } catch (error) {
                                            console.error("Error downloading excel:", error);
                                        }
                                    }}
                                    btnName="Download Excel"
                                />
                            </div>
                            {/* <div className="me-2">
                                 <DownloadExcelButton  searchValue={searchValue} selectedDistrictId={selectedDistrictId} 
                                selectedSubCategoryId={selectedSubCategoryId} selectedSportId={selectedSportId} />
                            </div> */}

                            <div>
                                <RefreshButton refreshCallback={handleRefresh} />


                            </div>

                        </div>




                    </div>

                    <div className="d-lg-flex mt-3 mx-4">
                        <div>
                            <SportFilter setCurrentPage={setCurrentPage} />
                        </div>
                        <div className="mx-lg-2 mb-2">
                            <Form.Select
                                value={selectedStatus}
                                onChange={handleStatusChange}
                                className="me-2"
                                style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                            >
                                <option value="0">All Status</option>
                                <option value="reject">Reject</option>
                                <option value="pass">Pass</option>
                                <option value="final_submit">Final Submit</option>
                                <option value="ongoing">ongoing</option>
                                <option value="ask_for_resubmit">Ask for Resubmit</option>
                            </Form.Select>
                        </div>
                        {!(user?.role === 'admin' && user?.user_level === '3') && (
                            <div className="mx-1 mb-2">
                                <DistrictFilter setCurrentPage={setCurrentPage} />

                            </div>
                        )}

                        <div className="mx-1">
                            <CategorySubCategoryFilter typeId="1"
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                selectedSubCategory={selectedSubCategory}
                                setSelectedSubCategory={setSelectedSubCategory}
                                placeholderText="Individual"
                                setCurrentPage={setCurrentPage}
                            />
                        </div>





                    </div>


                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>

                        ) : (

                            <div className="w-100 table-responsive">
                                <div id="example_wrapper" className="dataTables_wrapper">
                                    <form>
                                        <table id="example" className="display w-100 dataTable">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Prov.Reg.Id</th>
                                                    <th>Applicant Full Name</th>
                                                    {/* <th>Email Id</th> */}
                                                    <th>Contact Number</th>
                                                    <th>Registration Date</th>
                                                    <th>Attempt</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {organisationdataList?.data?.length > 0 ? (
                                                    organisationdataList?.data?.map((data, index) => {
                                                        return (
                                                            <tr key={data?.id}>
                                                                <td>{index + 1 + (currentPage - 1) * perPage}</td>  {/* Correct Serial Number */}
                                                                <td>{data?.provisinal_registration_id}</td>
                                                                <td>{data?.name}</td>
                                                                {/* <td>{data?.email}</td> */}
                                                                {/* <td>{data?.mobile}</td> */}
                                                                <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                                <td>{formatDateTime(data?.created_at)}</td>
                                                                <td>{data?.attempt_count + 1}</td>
                                                                <td style={{ color: getStatusColor(data?.status) }}>
                                                                    {data?.status && formatStatus(data?.status)}
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleVerificationClick(data?.id)} disabled={data?.status === "pass"}>
                                                                            Verify Application
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center">Data is not available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </form>
                                </div>
                            </div>

                        )}

                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={2}
                    pageCount={Math.ceil(organisationdataList?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item mx-1 my-1"
                    pageLinkClassName="page-link"
                    previousClassName="page-item mx-1 my-1"
                    previousLinkClassName="page-link"
                    nextClassName="page-item mx-1 my-1"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item mx-1 my-1"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap "
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />

            </div>
        </>
    );
};

export default IndividualList;

